import React, { useState } from "react";
import { IFeedbackQuestion } from "../feedback.type";
import { Button, TextField } from "@material-ui/core";
import { feedbackStyle } from "../style";

export const FreeTextFeedbackQuestion: React.FC<IFeedbackQuestion> = (
	props
) => {
	const [disabled, setDisabled] = useState(false);
	const [showButton, setShowButton] = useState(false);
	const [value, setValue] = useState("");
	const { question } = props;
	const classes = feedbackStyle();

	if (!question || question.type !== "free_text") {
		return null;
	}

	const containerClasses = [
		classes.scaleContainer,
		classes.freeTextContainer,
		disabled ? classes.disabled : "",
	];

	const handleSubmit = () => {
		if (!value) {
			return;
		}
		if (props.onChange) {
			props.onChange(question.id, value);
		}
		setDisabled(true);
		setTimeout(() => {
			setDisabled(false);
		}, 800);
	};

	return (
		<div className={containerClasses.join(" ")}>
			<TextField
				id={`${question.commonId}`}
				key={`${question.commonId}`}
				aria-label={`free-text-${question.commonId}`}
				label={question.config.placeholder}
				className={classes.freeTextTextArea}
				rows={4}
				multiline
				variant="outlined"
				fullWidth
				value={value}
				onBlur={()=>{!value && setShowButton(false)}}
				onClick={()=>setShowButton(true)}
				onChange={(e) => setValue(e.target.value)}
			/>
			<Button
				variant="outlined"
				color="primary"
				size="small"
				onClick={handleSubmit}
				disabled={disabled}
				style={{
					visibility: !showButton ? "hidden" : "visible",
				}}
			>
				Invia commento
			</Button>
		</div>
	);
};
